import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CartNotEmptyGuard } from '@spartacus/checkout/base/components';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CardModule, SpinnerModule } from '@spartacus/storefront';
import { CustomCheckoutAuthGuard } from '../../guards/custom-checkout-auth.guard';
import { CustomPaymentFormModule } from "./custom-payment-form/custom-payment-form.module";
import { CustomPaymentMethodComponent } from './custom-payment-method.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CardModule,
    SpinnerModule,
    I18nModule,
    CustomPaymentFormModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutPaymentDetails: {
          component: CustomPaymentMethodComponent,
          guards: [CustomCheckoutAuthGuard, CartNotEmptyGuard],
        },
      },
    } as CmsConfig),
  ],
  declarations: [CustomPaymentMethodComponent],
  exports: [CustomPaymentMethodComponent]
})
export class CustomPaymentMethodModule {
}
